export enum BusinessServiceLocationType {
    UNKNOWN,
    PHYSICAL,
    ONLINE
}